<template>
  <div>
    <b-table :data="dataTable" :bordered="true" :striped="true">
        <b-table-column field="facture" :label="$t('remiseBancaire.ajoutReglement.facture')"
                        v-slot="props">
          <router-link-blank
          :to="getRouteName(props.row)"
          :message="props.row.libelle"
          />
        </b-table-column>
        <b-table-column field="dateEcheance" v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglement.dateEcheance')">
          <span>{{props.row.dateEcheance}}</span>
        </b-table-column>
        <b-table-column field="montant" v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglement.montant')"
                        class="right">
          <span>{{props.row.montant | formatDevise}}</span>
        </b-table-column>
        <b-table-column field="inputLetterage" v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglement.montantAffecte')"
                        class="right">
          {{props.row.inputLetterage | formatDevise}}
        </b-table-column>
        <b-table-column field="inputLetterage" v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglement.montantsAvoirs')"
                        class="right">
          {{getMontantAvoirs(props.row) | formatDevise}}
        </b-table-column>
        <b-table-column field="solde" v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglement.solde')"
                        class="right">
          <span>{{props.row.solde | formatDevise}}</span>
        </b-table-column>
      <template slot="footer">
        <div class="has-text-left">
          {{ $t('remiseBancaire.nonLettre') }}
          <span class="has-text-weight-bold">{{ resteALettrer | formatDevise}}</span>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import genererTableauDesLettragesModification from '@/services/remiseBancaire/initLettragesModification';
import { get } from '@/api/mouvementClient/index';
import messageErreur from '@/services/general/messageErreur';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { SENS_VENTE, MODULE_BAIL, MODULE_TLPE } from '@/configuration/devisConf';
import { LETTRAGE_TYPE_AVOIR } from '@/configuration/lettrageConf';

export default {
  props: {
    data: Object,
  },
  components: {
    routerLinkBlank,
  },
  data() {
    return {
      dataTable: [],
      resteALettrer: 0,
      vente: SENS_VENTE,
    };
  },
  methods: {
    getLettragesAvoirs(mvt) {
      return mvt.tousLettrages
        .filter((lettrage) => { return lettrage.lettrageType === LETTRAGE_TYPE_AVOIR; });
    },
    getMontantAvoirs(mvt) {
      const montantsAvoirs = this.getLettragesAvoirs(mvt)
        .map((lettrage) => { return lettrage.montant; });
      if (montantsAvoirs.length > 0) {
        return montantsAvoirs
          .reduce((accumulator, currentValue) => { return accumulator + currentValue; });
      }
      return 0;
    },
    getRouteName(info) {
      const isFactureNull = info.idFacture === null;
      const module = info.facture?.module;
      const routes = {
        default: isFactureNull ? 'c.bodac.remises_bancaires' : 'c.bodac.factures',
        [MODULE_BAIL]: isFactureNull ? 'c.baux.lot_paiement' : 'c.baux.facture_achat',
        [MODULE_TLPE]: isFactureNull ? 'c.gabed.lot_paiement_recette' : 'c.gabed.titre_recette',
      };

      const nameRoute = routes[module] || routes.default;

      return {
        name: nameRoute,
        params: { id: isFactureNull ? info.remiseBancaireId : info.idFacture },
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.dataTable = await genererTableauDesLettragesModification(
        this.data.lettrages,
        this.data.id,
        [],
      );
      const jsonTemporaireRecuperationResteLettrage = await get(this.data.id);
      this.resteALettrer = jsonTemporaireRecuperationResteLettrage.data.result.resteALettrer;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>

<style>
</style>
